module.exports = __webpack_public_path__ + "static/media/T&C CS-TM EN.d42363c6.pdf";